import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Box,
  CircularProgress,
  Stack,
  Typography,
} from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import WarningAmberIcon from "@mui/icons-material/WarningAmber";
import DescriptionOutlinedIcon from "@mui/icons-material/DescriptionOutlined";

import { renderDiscrepancyBadges } from "../PopUp/EcrfDiscrepancyPopUp";

const EcrfDiscrepancySection = ({ ecrfDiscrepancies, onClick, loading = false }) => {
  const total = ecrfDiscrepancies?.total || 0;
  if (!loading && total <= 0) return null;

  return (
    <Accordion
      disableGutters
      elevation={0}
      data-testid="ecrf-discrepancy-accordion"
      sx={{
        border: "1px solid",
        borderColor: "warning.light",
        bgcolor: "warning.50",
        mt: 2,
        borderRadius: 2,
        "&:first-of-type": { borderRadius: 2 },
        "&:last-of-type": { borderRadius: 2 },
        "&:before": { display: "none" },
      }}
    >
      <AccordionSummary
        expandIcon={<ExpandMoreIcon />}
        sx={{ "& .MuiAccordionSummary-content": { alignItems: "center" } }}
      >
        <Stack direction="row" spacing={1} alignItems="center">
          <WarningAmberIcon color="warning" fontSize="small" />
          <Typography variant="subtitle2" fontWeight="bold">
            Discrepancies
          </Typography>
          {loading ? (
            <CircularProgress size={14} data-testid="ecrf-discrepancy-header-loader" />
          ) : (
            <Box
              sx={{
                bgcolor: "#1e293b",
                color: "#fff",
                borderRadius: 5,
                minWidth: 28,
                textAlign: "center",
                px: 1,
                py: 0.25,
                fontWeight: 700,
                fontSize: "0.85rem",
              }}
            >
              {total}
            </Box>
          )}
        </Stack>
      </AccordionSummary>

      <AccordionDetails sx={{ pt: 0 }}>
        {loading ? (
          <Stack direction="row" spacing={1} alignItems="center">
            <CircularProgress size={16} />
            <Typography variant="body2" color="text.secondary">
              Checking eCRFs…
            </Typography>
          </Stack>
        ) : (
          <>
            <Stack
              direction="row"
              spacing={1}
              alignItems="center"
              onClick={onClick}
              data-testid="ecrf-discrepancy-widget"
              sx={{ cursor: "pointer", width: "fit-content" }}
            >
              <Stack
                direction="row"
                spacing={0.5}
                alignItems="center"
                sx={{
                  border: "1px solid",
                  borderColor: "divider",
                  borderRadius: 5,
                  px: 1,
                  py: 0.25,
                }}
              >
                <DescriptionOutlinedIcon fontSize="small" sx={{ color: "success.main" }} />
                <Typography variant="body2">eCRF</Typography>
              </Stack>

              <Box
                sx={{
                  bgcolor: "#1e293b",
                  color: "#fff",
                  borderRadius: 5,
                  minWidth: 28,
                  textAlign: "center",
                  px: 1,
                  py: 0.25,
                  fontWeight: 700,
                  fontSize: "0.85rem",
                }}
              >
                {total}
              </Box>
            </Stack>

            <Box mt={1}>{renderDiscrepancyBadges(ecrfDiscrepancies?.by_type)}</Box>
          </>
        )}
      </AccordionDetails>
    </Accordion>
  );
};

export default EcrfDiscrepancySection;
